import { useAuth } from './useAuth';

export function useWorkspaceLimit() {
  const { user } = useAuth();

  const limit = user?.workspaceLimit ?? 1;
  const currentCount = user?.workspaceCount ?? 0;
  const canCreateWorkspace = currentCount < limit;
  const remainingSlots = Math.max(0, limit - currentCount);

  return {
    plan: user?.plan ?? 'free',
    limit,
    currentCount,
    canCreateWorkspace,
    remainingSlots,
  };
}
